import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import Slider from "react-slick";

// Customizable Area Start
import React from "react";
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  currentSectionIndex: number;
  videoPlaying: boolean;
  videoPlaying1: boolean;
  videoPlaying2: boolean;

  currentSlide: number;
  connectSectionData : ConnectSectionData;
  pitchSectionData:PitchSectionData;
  testimonialsData:TestimonialData;
  footerData:FooterData;
  // Customizable Area End
}

interface FooterData {
  data: FooterItem[];
}

interface FooterItem {
  email: string;
  phone: string;
  social_links: SocialLinks;
  footer_image_url: string;
}

interface SocialLinks{
  facebook: string;
  instagram: string;
  twitter: string;
  linkedin: string;
}

interface ConnectSectionData {
  data: ConnectItem[];
}

interface PitchSectionData {
  data: PitchItem[];
}

interface TestimonialData {
  data: TestimonialItem[];
}

interface ConnectItem {
  id: number;
  connect_subtext: string;
  video_url: string;
}

interface PitchItem {
  id: number;
  pitch_subtext: string;
  video_url: string;
}

interface TestimonialItem {
  id: number;
  name: string;
  designation: string;
  content: string;
  image_url: string;
}

interface SS {
  id: any;
  navigation: string;
}

export default class LandingPageController extends BlockComponent<
  Props,
  S,
  SS
> {

  connectSectionDataApiCallId: string = "";
  pitchSectionDataApiCallId: string = "";
  testimonialsDataApiCallId: string = "";
  footerDataApiCallId: string = "";
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIRequestMessage),
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      getName(MessageEnum.RestAPIRequestMethodMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.ScrollToConnectSectionMessage),
      getName(MessageEnum.ScrollToPitchSectionMessage),
    ];

    this.state = {
      currentSlide: 0,
      currentSectionIndex: 0,
      videoPlaying: false,
      videoPlaying1: false,
      videoPlaying2: false,
  
      connectSectionData: {
        data: [],
      },
      pitchSectionData: {
        data: [],
      },
      testimonialsData: {
        data: [],
      },
      footerData: {
        data: [],
      },
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }


  async componentDidMount() {
    super.componentDidMount();
    this.connectSectionData();
    this.pitchSectionData();
    this.testimonialsData();
    this.footerData();

    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.addEventListener('scroll', this.handleScroll);
  }

  async componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      let responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      ); 
    
    if (apiRequestCallId === this.connectSectionDataApiCallId){
      if(responseJson?.data){
        this.setState({
          connectSectionData: {
            data: responseJson.data
          }
        });
      }
    }
    if (apiRequestCallId === this.pitchSectionDataApiCallId){
      if(responseJson?.data){
        this.setState({
          pitchSectionData: {
            data: responseJson.data
          }
        });
      }
    }
    if (apiRequestCallId === this.testimonialsDataApiCallId){
      if(responseJson?.data){
        this.setState({
          testimonialsData: {
            data: responseJson.data
          }
        });
        console.log('testimonial', this.state.testimonialsData)
      }
    }
    if (apiRequestCallId === this.footerDataApiCallId){
      if(responseJson?.data){
        this.setState({
          footerData: {
            data: responseJson.data
          }
        });
      }
    }
    }
    if (getName(MessageEnum.ScrollToConnectSectionMessage) === message.id) {
      this.scrollToConnectSection();
    }
    if (getName(MessageEnum.ScrollToPitchSectionMessage) === message.id) {
      this.scrollToPitchSection();
    }
    // Customizable Area End
  }

  // Customizable Area Start

  public sliderRef: React.RefObject<Slider> = React.createRef();
  public videoRef: React.RefObject<HTMLVideoElement> = React.createRef();
  public videoRef1: React.RefObject<HTMLVideoElement> = React.createRef();
  public videoRef2: React.RefObject<HTMLVideoElement> = React.createRef();

  handleScroll = () => {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const sections = document.querySelectorAll('section');
  
    sections.forEach((section, index) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
  
      if (scrollPosition >= sectionTop - windowHeight / 2 && 
          scrollPosition < sectionTop + sectionHeight / 2) {
        if (index < sections.length - 1) {
          sections[index + 1].scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  };

  scrollToConnectSection = () => {
    const connectSection = document.getElementById("connect-section");
    if (connectSection) {
      connectSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  scrollToPitchSection = () => {
    const pitchSection = document.getElementById("pitch-section");
    if (pitchSection) {
      pitchSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  scrollToTestimonialSection = () => {
    const testimonialSection = document.getElementById("testimonial-section");
    if (testimonialSection) {
      testimonialSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  scrollToMarketingSection = () => {
    const marketingSection = document.getElementById("marketing-section");
    if (marketingSection) {
      marketingSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  scrollToFooterSection = () => {
    const footerSection = document.getElementById("footer-section");
    if (footerSection) {
      footerSection.scrollIntoView({ behavior: "smooth" });
    }
  }

// Update the methods to use protected sliderRef
handleLeftArrowClick = () => {
  if (this.sliderRef.current) {
    this.sliderRef.current.slickPrev();
  }
};

handleRightArrowClick = () => {
  if (this.sliderRef.current) {
    this.sliderRef.current.slickNext();
  }
};

  goToHome() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationHomeScreenMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }
  handlePlay = () => {
    this.setState({ videoPlaying: true });
  };

  handlePause = () => {
    this.setState({ videoPlaying: false });
  };

  handlePlayPause = () => {
    const video = this.videoRef.current;
  if (video) {
    if (this.state.videoPlaying) {
      video.pause();
      this.setState({ videoPlaying: false });
    } else {
      video.play();
      this.setState({ videoPlaying: true });
    }
  }
  };

  handlePlayPause1 = () => {
    const video = this.videoRef1.current;
  if (video) {
    if (this.state.videoPlaying1) {
      video.pause();
      this.setState({ videoPlaying1: false });
    } else {
      video.play();
      this.setState({ videoPlaying1: true });
    }
  }
  };

  handlePlayPause2 = () => {
    const video = this.videoRef2.current;
  if (video) {
    if (this.state.videoPlaying2) {
      video.pause();
      this.setState({ videoPlaying2: false });
    } else {
      video.play();
      this.setState({ videoPlaying2: true });
    }
  }
  };
  
  scrollDown = (sectionNumber:number) => {
    this.setState({ currentSectionIndex: sectionNumber });
    window.scrollBy({ top: 500, behavior: "smooth" });
  };

  handleVideoEnd = () => {
    const video = this.videoRef.current;
    if (video) {
      video.currentTime = 0;
    }
    this.setState({ videoPlaying: false });
  };

  handleVideoEnd1 = () => {
    const video = this.videoRef1.current;
    if (video) {
      video.currentTime = 0;
    }
    this.setState({ videoPlaying1: false });
  };

  handleVideoEnd2 = () => {
    const video = this.videoRef2.current;
    if (video) {
      video.currentTime = 0;
    }
    this.setState({ videoPlaying2: false });
  };

  connectSectionData = () => {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
  
    const connectSectionDataMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.connectSectionDataApiCallId = connectSectionDataMsg.messageId;
  
    connectSectionDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.connectSectionDataAPiEndPoint
    );
  
    connectSectionDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
  
    connectSectionDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
  
    runEngine.sendMessage(connectSectionDataMsg.id, connectSectionDataMsg);
  };

  pitchSectionData = () => {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
  
    const pitchSectionDataMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.pitchSectionDataApiCallId = pitchSectionDataMsg.messageId;
  
    pitchSectionDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.pitchSectionDataAPiEndPoint
    );
  
    pitchSectionDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
  
    pitchSectionDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
  
    runEngine.sendMessage(pitchSectionDataMsg.id, pitchSectionDataMsg);
  };

  testimonialsData = () => {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
  
    const testimonialsDataMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.testimonialsDataApiCallId = testimonialsDataMsg.messageId;
  
    testimonialsDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.testimonialsDataAPiEndPoint
    );
  
    testimonialsDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
  
    testimonialsDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
  
    runEngine.sendMessage(testimonialsDataMsg.id, testimonialsDataMsg);
  };

  footerData = () => {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
  
    const footerDataMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.footerDataApiCallId = footerDataMsg.messageId;
  
    footerDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.footerDataAPiEndPoint
    );
  
    footerDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
  
    footerDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
  
    runEngine.sendMessage(footerDataMsg.id, footerDataMsg);
  };
  // Customizable Area End
}
